import { createBfzArticleTeaserLink } from "components/page-components/Teaser-Cards/utils"
import createISODateWithGermanTimezone from "scripts/createISODateWithGermanTimezone"
import doenerCase from "scripts/doenerCase"
import { getSrc } from "gatsby-plugin-image"

export const createBfzCollectionPageSchemaOrgData = ({
  all_articles,
  title,
  canon_slug,
  seo_description,
  same_as,
}) => {
  const schema_org_data = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    headline: `News zu ${title} - aktuelle Nachrichten im Überblick`,
    url: `https://bi-medien.de${canon_slug}`,
    description: seo_description,
    // description: `Aktuelle News zu ${title}: Hier finden Sie alle aktuellen Meldungen und Informationen zu ${title} ► bi-medien.de`,
    about: {
      "@type": "Thing",
      name: title,
      sameAs: !!same_as ? same_as : undefined,
      // "sameAs": "https://de.wikipedia.org/wiki/[thema]",
      // "sameAs": "https://HomepageDerMesse",
    },
    hasPart: all_articles?.map((article) => {
      const {
        authors,
        article_date,
        thumbnail,
        thumbnail_large,
        meta_description,
        last_update,
        seo_title,
      } = article
      const human_authors = [
        ...authors?.filter(({ type, name }) => type === "Person" && !!name),
      ].sort((a, b) => !!b.strapi_data - !!a.strapi_data)
      const organization_authors = authors?.filter(
        ({ type, name }) => type === "Organization" && !!name
      )
      const all_authors = [...human_authors, ...organization_authors]
      const main_author = all_authors?.[0]

      const social_profiles = !!main_author?.strapi_data
        ? [
            main_author?.strapi_data?.facebook,
            main_author?.strapi_data?.linkedIn,
            main_author?.strapi_data?.twitter,
            main_author?.strapi_data?.xing,
          ].filter((profile) => profile)
        : null
      const part = {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        url: `https://bi-medien.de${createBfzArticleTeaserLink(article)}`,
        headline: seo_title,
        datePublished: createISODateWithGermanTimezone(article_date),
        dateModified: last_update
          ? createISODateWithGermanTimezone(last_update)
          : undefined,
        description: meta_description + " ► Mehr erfahren!",
        publisher: {
          "@type": "Organization",
          name: "B_I MEDIEN",
          logo: {
            "@type": "ImageObject",
            url: `https://bi-medien.de/assets/b-i-medien-publisher-logo.png`,
          },
        },
        image: {
          "@type": "ImageObject",
          url: `https://bi-medien.de${getSrc(thumbnail || thumbnail_large)}`,
        },
        author: {
          "@type": main_author?.type || "Organization",
          name: main_author?.name || "B_I MEDIEN",
          url: !!main_author?.strapi_data
            ? `https://bi-medien.de/ueber-uns/redaktion/${doenerCase(
                all_authors[0].name
              )}`
            : undefined,
          sameAs: !!social_profiles ? social_profiles : undefined,
        },
      }
      return part
    }),
  }

  return schema_org_data
}
